var render = function () {
  var _class;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "transaction",
    class: (_class = {
      'empty': !_vm.transaction.owner_id,
      'arranger_is_fixed': _vm.SCROLL_STATES.Filters_block_is_fixed
    }, _class[_vm.getIconStyleClass] = true, _class[_vm.getMultiBillClass] = true, _class[_vm.getBillTypeClass] = true, _class)
  }, [_c('div', {
    staticClass: "transaction-title"
  }, [_vm._v(_vm._s(_vm.$t('transaction.information')))]), !_vm.transaction.owner_id ? [_vm.isPersonalProject ? [!_vm.MERCHANT_INFO.botSigned ? _c('telegram-information-panel') : _vm._e(), _c('report-information-panel'), _c('widget-information-panel')] : [_vm.TRANSACTIONS.result.length > 0 ? _c('div', {
    staticClass: "choose-transaction"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('select.transaction.details'))
    }
  })]) : _vm._e()]] : _vm.isIOS ? _c('div', {
    directives: [{
      name: "scrollbar",
      rawName: "v-scrollbar",
      value: {
        id: "scroll-transaction-".concat(_vm.transaction.public_id)
      },
      expression: "{\n      id: `scroll-transaction-${transaction.public_id}`\n    }"
    }],
    staticClass: "transaction_block"
  }, [_c('cs-scrollbar-vertical', {
    staticClass: "scroll-transaction",
    attrs: {
      "id": "scroll-transaction-".concat(_vm.transaction.public_id)
    }
  }), _vm.transactionTypeIs(_vm.transaction, 'orders') ? [_c('transfer-transaction-details', {
    attrs: {
      "transaction": _vm.transaction,
      "permission": _vm.isPersonalProject
    },
    on: {
      "close": _vm.CLOSE_TRANSACTION
    }
  })] : _vm._e(), _vm.transactionTypeIs(_vm.transaction, 'partner') ? [_c('partner-transaction-details', {
    attrs: {
      "transaction": _vm.transaction,
      "permission": _vm.isPersonalProject
    },
    on: {
      "close": _vm.CLOSE_TRANSACTION
    }
  })] : _vm._e(), _vm.transactionTypeIs(_vm.transaction, 'bills') ? [_c('bill-card-header', {
    attrs: {
      "transaction": _vm.transaction,
      "permission": _vm.isPersonalProject
    }
  }), _c('bill-card-content', {
    attrs: {
      "transaction": _vm.transaction,
      "permission": _vm.isPersonalProject
    }
  }), _vm.isPersonalProject ? _c('bill-card-footer', {
    attrs: {
      "transaction": _vm.transaction,
      "permission": _vm.isPersonalProject
    }
  }) : _vm._e()] : _vm._e(), _vm.transactionTypeIs(_vm.transaction, 'payoutsAndRefunds') ? [_c('div', {
    staticClass: "transaction_header"
  }, [_c('button', {
    staticClass: "transaction_block-close",
    on: {
      "click": _vm.CLOSE_TRANSACTION
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.close')) + " ")]), _c('div', {
    staticClass: "transaction_header-title"
  }, [_vm._v(" " + _vm._s(_vm.getTextByOrderType(_vm.transaction.type)) + " — " + _vm._s(_vm._f("date")(_vm.transaction.created_at, 'DD.MM.YYYY HH:mm')) + " "), _vm.transaction.public_parent_id && _vm.transaction.type === 'REFUND' ? [_c('br'), _vm._v(" " + _vm._s(_vm.$t('for.transfer.number', {
    publicId: _vm.transaction.public_parent_id
  })) + " ")] : _vm._e()], 2), _c('div', {
    staticClass: "transaction_header-info"
  }, [_vm._v(" " + _vm._s(_vm.formattedRefundAmount) + " ")])]), _c('div', {
    staticClass: "transaction_info"
  }, [_vm.transaction.amount ? _c('div', {
    staticClass: "info_box card-transfer"
  }, [_vm.isCurrencyCrypto ? _c('div', {
    staticClass: "info_box-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('sent.to.wallet'))
    }
  }) : _c('div', {
    staticClass: "info_box-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('sent.to.card'))
    }
  }), _c('div', {
    staticClass: "info_box-content"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.displayTransactionAmount) + " ")])])]) : _vm._e(), _vm.transaction.commission ? _c('div', {
    staticClass: "info_box comission"
  }, [_c('div', {
    staticClass: "info_box-title"
  }, [_vm._v(_vm._s(_vm.$t('commission.of.service')))]), _c('div', {
    staticClass: "info_box-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.displayTransactionCommission))])])]) : _vm._e(), _vm.transaction.account_number ? _c('div', {
    staticClass: "info_box sender"
  }, [_c('div', {
    staticClass: "info_box-title"
  }, [_vm._v(_vm._s(_vm.$t('common.recipient')))]), _c('div', {
    staticClass: "info_box-content"
  }, [_vm.isApplePaymentMethod ? _c('span', [_vm._v(" " + _vm._s(_vm.getFormattedAppleMethodName) + " ")]) : _vm.isGooglePaymentMethod ? _c('span', [_vm._v(" " + _vm._s(_vm.getFormattedGoogleAccountNumber) + " ")]) : _vm.isCurrencyCrypto ? _c('span', [_vm._v(" " + _vm._s(_vm.transaction.account_number) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.getTransactionCardType) + " " + _vm._s(_vm._f("accountNumberShort")(_vm.transaction.account_number)) + " ")]), _vm.transaction.refund_email_recipient ? _c('p', {
    staticClass: "text-textarea"
  }, [_vm._v(" " + _vm._s(_vm.transaction.refund_email_recipient) + " ")]) : _vm._e()])]) : _vm._e(), _vm.transaction.description ? _c('div', {
    staticClass: "info_box comment"
  }, [_c('div', {
    staticClass: "info_box-title"
  }, [_vm._v(_vm._s(_vm.$t('common.description')))]), _c('div', {
    staticClass: "info_box-content"
  }, _vm._l(_vm.splitedDescription, function (description) {
    return _c('p', {
      key: description
    }, [_vm._v(" " + _vm._s(description) + " ")]);
  }), 0)]) : _vm._e()]), _vm.isPersonalProject ? _c('div', {
    staticClass: "transaction_footer"
  }, [_vm.isShownRepeatPayoutButton ? _c('a', {
    staticClass: "repeat",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'payout',
          params: {
            transaction: _vm.transaction
          }
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.repeat')) + " ")]) : _vm._e(), _c('a', {
    staticClass: "receipt",
    class: {
      'float-none': _vm.transaction.type === 'REFUND'
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleSendReceipt($event);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.receipt')) + " ")])]) : _vm._e()] : _vm._e()], 2) : _c('div', {
    staticClass: "transaction_block"
  }, [_vm.transactionTypeIs(_vm.transaction, 'orders') ? [_c('transfer-transaction-details', {
    attrs: {
      "transaction": _vm.transaction,
      "permission": _vm.isPersonalProject
    },
    on: {
      "close": _vm.CLOSE_TRANSACTION
    }
  })] : _vm._e(), _vm.transactionTypeIs(_vm.transaction, 'partner') ? [_c('partner-transaction-details', {
    attrs: {
      "transaction": _vm.transaction,
      "permission": _vm.isPersonalProject
    },
    on: {
      "close": _vm.CLOSE_TRANSACTION
    }
  })] : _vm._e(), _vm.transactionTypeIs(_vm.transaction, 'bills') ? [_c('bill-card-header', {
    attrs: {
      "transaction": _vm.transaction,
      "permission": _vm.isPersonalProject
    }
  }), _c('bill-card-content', {
    attrs: {
      "transaction": _vm.transaction,
      "permission": _vm.isPersonalProject
    }
  }), _vm.isPersonalProject ? _c('bill-card-footer', {
    attrs: {
      "transaction": _vm.transaction,
      "permission": _vm.isPersonalProject
    }
  }) : _vm._e()] : _vm._e(), _vm.transactionTypeIs(_vm.transaction, 'payoutsAndRefunds') ? [_c('div', {
    staticClass: "transaction_header"
  }, [_c('button', {
    staticClass: "transaction_block-close",
    on: {
      "click": _vm.CLOSE_TRANSACTION
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.close')) + " ")]), _c('div', {
    staticClass: "transaction_header-title"
  }, [_vm._v(" " + _vm._s(_vm.getTextByOrderType(_vm.transaction.type)) + " — " + _vm._s(_vm._f("date")(_vm.transaction.created_at, 'DD.MM.YYYY HH:mm')) + " "), _vm.transaction.public_parent_id && _vm.transaction.type === 'REFUND' ? [_c('br'), _vm._v(" " + _vm._s(_vm.$t('for.transfer.number', {
    publicId: _vm.transaction.public_parent_id
  })) + " ")] : _vm._e()], 2), _c('div', {
    staticClass: "transaction_header-info"
  }, [_vm._v(" " + _vm._s(_vm.formattedRefundAmount) + " ")])]), _c('div', {
    staticClass: "transaction_info"
  }, [_vm.transaction.amount ? _c('div', {
    staticClass: "info_box card-transfer"
  }, [_vm.isCurrencyCrypto ? _c('div', {
    staticClass: "info_box-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('sent.to.wallet'))
    }
  }) : _c('div', {
    staticClass: "info_box-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('sent.to.card'))
    }
  }), _c('div', {
    staticClass: "info_box-content"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.displayTransactionAmount) + " ")])])]) : _vm._e(), _vm.transaction.commission ? _c('div', {
    staticClass: "info_box comission"
  }, [_c('div', {
    staticClass: "info_box-title"
  }, [_vm._v(_vm._s(_vm.$t('commission.of.service')))]), _c('div', {
    staticClass: "info_box-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.displayTransactionCommission))])])]) : _vm._e(), _vm.transaction.account_number ? _c('div', {
    staticClass: "info_box sender"
  }, [_c('div', {
    staticClass: "info_box-title"
  }, [_vm._v(_vm._s(_vm.$t('common.recipient')))]), _c('div', {
    staticClass: "info_box-content"
  }, [_vm.isApplePaymentMethod ? _c('span', [_vm._v(" " + _vm._s(_vm.getFormattedAppleMethodName) + " ")]) : _vm.isGooglePaymentMethod ? _c('span', [_vm._v(" " + _vm._s(_vm.getFormattedGoogleAccountNumber) + " ")]) : _vm.isCurrencyCrypto ? _c('span', [_vm._v(" " + _vm._s(_vm.transaction.account_number) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.getTransactionCardType) + " " + _vm._s(_vm._f("accountNumberShort")(_vm.transaction.account_number)) + " ")]), _vm.transaction.refund_email_recipient ? _c('p', {
    staticClass: "text-textarea"
  }, [_vm._v(" " + _vm._s(_vm.transaction.refund_email_recipient) + " ")]) : _vm._e()])]) : _vm._e(), _vm.transaction.description ? _c('div', {
    staticClass: "info_box comment"
  }, [_c('div', {
    staticClass: "info_box-title"
  }, [_vm._v(_vm._s(_vm.$t('common.description')))]), _c('div', {
    staticClass: "info_box-content"
  }, _vm._l(_vm.splitedDescription, function (description) {
    return _c('p', {
      key: description
    }, [_vm._v(" " + _vm._s(description) + " ")]);
  }), 0)]) : _vm._e(), _vm.transaction.billPromoCode ? _c('div', [_c('bill-promo-code', {
    attrs: {
      "content": _vm.getBillPromoCode
    }
  })], 1) : _vm._e()]), _vm.isPersonalProject ? _c('div', {
    staticClass: "transaction_footer"
  }, [_vm.isShownRepeatPayoutButton ? _c('a', {
    staticClass: "repeat",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'payout',
          params: {
            transaction: _vm.transaction
          }
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.repeat')) + " ")]) : _vm._e(), _c('a', {
    staticClass: "receipt",
    class: {
      'float-none': _vm.transaction.type === 'REFUND'
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleSendReceipt($event);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.receipt')) + " ")])]) : _vm._e()] : _vm._e()], 2)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }